import {valueValidatableInitialize, valueValidatableClearance} from './valueValidatableInitialize';

const comboBoxInputInitialize = (RMI, contextId, compId) => valueValidatableInitialize(RMI, contextId, compId);

const comboBoxInputClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {comboBoxInputInitialize, comboBoxInputClearance};
